import ImageItem from 'rlink-media/ImageItem';

export default class History extends ImageItem {
  get adminLabel () {
    return this.title.length > 0 ? this.title : '<untitled history item>';
  }

  static defaultData () {
    return {
      iconPath: '',
      ...ImageItem.defaultData(),
    };
  }

  imageFormats () {
    return [
      ...super.imageFormats(),
      this.iconImageFormats,
    ];
  }

  get mainImageFormats () {
    return {
      src: this.imagePath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/jpeg', fileExt: 'jpg'},
      ],
      widths: [
        1920, 1440, 1024,
      ],
    };
  }

  get iconImageFormats () {
    return {
      src: this.iconPath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/png', fileExt: 'png'},
      ],
      widths: [
        640, 480, 341, 213,
      ],
    };
  }

  get linkedContentPaths () {
    return [
      ...super.linkedContentPaths(),
      this.iconPath,
    ];
  }

  get year () {
    return this.data.get('year', '');
  }

  get iconPath () {
    return this.data.get('iconPath', this.constructor.defaultData().iconPath);
  }

  get description () {
    return this.data.get('description', '');
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/content-types/History.js